// Vendor libraries
import { combineReducers } from '@ngrx/store';
// Reducers
import { appStateSliceKey } from 'NewAngular/state/app-state/app-state.reducer';
import { calcInfo } from 'CalculationsApp/ts/state/calc-info.reducer';
import * as fundChartSharedReducers from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers';
import { savedItems } from 'NewAngular/features/components/saved-items/state/saved-items.reducer';
import { securitiesInfo } from 'SecuritiesApp/ts/state/securities-info/securities-info.reducer';
// Utils / Constants
import { FUND_CHART_SYSTEM_DEFAULT_STATE, FUND_CHART_APP_STATE_SLICE_KEY, } from 'ChartApp/ts/features/fundamental-chart/constants';
import { createReducerWithAppState } from 'NewAngular/state/app-state/utils';
export const fundChart = combineReducers({
    ...fundChartSharedReducers,
});
const initialSystemState = {
    [FUND_CHART_APP_STATE_SLICE_KEY]: FUND_CHART_SYSTEM_DEFAULT_STATE,
};
const initialUserState = {
    [FUND_CHART_APP_STATE_SLICE_KEY]: window.userProvidedAppState,
};
const reducers = combineReducers({
    appStateSliceKey,
    savedItems,
    fundChart,
    calcInfo,
    securitiesInfo,
});
export const rootReducer = createReducerWithAppState(reducers, initialSystemState, initialUserState);
